import styled from "@emotion/styled";
import { boxSizes, colors, fontSizes, gutterSizes } from "@gumtree/ui-library/src/base/theme";

export const Container = styled.section`
    margin-bottom: 56px;
    border: ${boxSizes.borderWidth} solid ${colors.bark20};
    border-radius: ${gutterSizes.base};
    padding: ${fontSizes.xlarge} ${fontSizes.xlarger};
    background: ${colors.branch5};
`;
